import { FC, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";

import { PartnerLoginForm } from "@/apps/partner/views/Login/PartnerLoginForm";
import { DefaultPageLayout } from "@/components/Layout/BaseLayouts/DefaultPageLayout";
import { WelcomeCard } from "@/views/WelcomeScreen/WelcomeCard";

export const WelcomePartnerPortal: FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);
  }, []);

  return (
    <DefaultPageLayout
      headline={t("partnerPortal:welcomeScreen.animationText")}
    >
      <div
        className="col-span-full flex flex-col items-center"
        data-testid="welcome-content"
      >
        <WelcomeCard>
          <PartnerLoginForm />
        </WelcomeCard>
        <div className="flex justify-center py-3">
          <p className="text-body-xs leading-md text-foreground-primary">
            <Trans
              t={t}
              i18nKey="partnerPortal:welcomeScreen.descriptionText"
              components={[
                <a
                  key="ratesLink"
                  href={t("Content.ratesLink")}
                  className="font-semibold text-foreground-primary underline"
                  target="_blank"
                  rel="noreferrer"
                />,
              ]}
            />
          </p>
        </div>
      </div>
    </DefaultPageLayout>
  );
};
